import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_create_standalone_count_tasksService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { warehouseId?: number, lotId?: number, expectedAmount?: number, projectId?: number, actualAmount?: number, expectedPackageId?: number, actualPackageId?: number, locationId?: number, materialId?: number, statusId?: number, vendorLotId?: number, jobId?: string, countTaskId?: number }): Promise<{ newTaskId?: number, errors?: string[], amountsEqual?: boolean }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

